import { createSlice } from "@reduxjs/toolkit";
import { ITourInitialState } from "./tourModel";
import {
  getAllMenuSectors,
  getAllRoomTypes,
  getAllTours,
  getTourDetails,
  insertInquiry,
} from "./services/tour.services";

const initialState: ITourInitialState = {
  loading: false,
  menuLoading: false,
  formLoading: false,
  error: "",
  MenuDomesticSectorList: [],
  MenuInternationalSectorList: [],
  TourList: [],
  TourDetails: {},
  RoomTypeList: [],
  FilterTourDetails: {
    RegionID: "",
    TravelType: "",
    IsHimalayanTreks: "",
    SectorID: "",
    Rate: "",
    NoOfDays: [],
    SpecialityType: "",
    OrderBy: "ORDER BY RATE ASC",
    CityName: "",
    SectorName: "",
    SectorURL: "",
    SpecialityURL: "",
    CityURL: "",
    TourType: [],
    PageIndex: 1,
    PageSize: 30,
  },
};

const tourSlice = createSlice({
  name: "tour",
  initialState,
  reducers: {
    setFilterTourDetails: (state, action) => {
      state.FilterTourDetails = action.payload;
    },
    clearFilterTourDetails: (state) => {
      state.FilterTourDetails = initialState.FilterTourDetails;
    },
    clearTourDetails: (state) => {
      state.TourDetails = initialState.TourDetails;
    },
    clearTourList: (state) => {
      state.TourList = initialState.TourList;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllMenuSectors.pending, (state) => {
      state.menuLoading = true;
    });
    builder.addCase(getAllMenuSectors.fulfilled, (state, action) => {
      state.menuLoading = false;
      state.MenuDomesticSectorList =
        (action.payload &&
          action.payload?.length > 0 &&
          action.payload?.filter(
            (sector: any) => sector?.SectorType === "DOMESTIC"
          )) ||
        [];
      state.MenuInternationalSectorList =
        (action.payload &&
          action.payload?.length > 0 &&
          action.payload?.filter(
            (sector: any) => sector?.SectorType === "INTERNATIONAL"
          )) ||
        [];
      state.error = "";
    });
    builder.addCase(getAllMenuSectors.rejected, (state, action) => {
      state.menuLoading = false;
      state.MenuDomesticSectorList = [];
      state.MenuInternationalSectorList = [];
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getAllTours.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllTours.fulfilled, (state, action) => {
      state.loading = false;
      state.TourList = action.payload || [];
      state.error = "";
    });
    builder.addCase(getAllTours.rejected, (state, action) => {
      state.loading = false;
      state.TourList = [];
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getAllRoomTypes.pending, (state) => {
      state.formLoading = true;
    });
    builder.addCase(getAllRoomTypes.fulfilled, (state, action) => {
      state.formLoading = false;
      state.RoomTypeList = action.payload || [];
      state.error = "";
    });
    builder.addCase(getAllRoomTypes.rejected, (state, action) => {
      state.formLoading = false;
      state.RoomTypeList = [];
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getTourDetails.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getTourDetails.fulfilled, (state, action) => {
      state.loading = false;
      state.TourDetails = action.payload;
      state.error = "";
    });
    builder.addCase(getTourDetails.rejected, (state, action) => {
      state.loading = false;
      state.TourDetails = initialState.TourDetails;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(insertInquiry.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(insertInquiry.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(insertInquiry.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export default tourSlice.reducer;
export const {
  setFilterTourDetails,
  clearFilterTourDetails,
  clearTourList,
  clearTourDetails,
} = tourSlice.actions;
